<div class="container">
    <div class="row">
        <div class="col-xs-12">
            <form role="form" name="emailDocumentsForm" id="emailDocumentsForm" #emailDocumentsForm="ngForm" novalidate (ngSubmit)="sendMail()">
                <div class="col-xs-12 border px-5 pt-4 pb-3">
                    <!-- Left Column: Email Form + HTML Editor -->
                    <div class="col-xs-6 px-0">
                    <!-- Email Form -->
                    <div class="col-xs-12" id="emailFormSection">
                        <div class="d-flex justify-content-between mb-2">
                            <div class="name ml-5 pl-2 pt-2 mt-1">
                                <span class="text-muted" style="font-size:13px; font-weight:bold;">By default, All Requisition Users are shown.</span>
                            </div>
                            <button type="button" class="btn btn-info" (click)="addNewEmployee()">
                                Add Employee
                            </button>
                        </div>
                        <div class="form-group d-flex align-items-center send-email-fields"
                            [ngClass]="{'has-error': emailDocumentsForm.submitted && selectedEmailSendToObjectsArray.length === 0}">
                            <label for="sendTo" class="control-label test-nowrap">
                                To<em>* </em> :
                            </label>
                            <div *ngIf="!isPrePopulatedUsersAvailable" class="width-100 skeleton-container">
                                <div class="skeleton-heading width-75 skeleton-loading my-0"></div>
                            </div>
                            <tag-input *ngIf="isPrePopulatedUsersAvailable" #sendToInput class="width-100 email-tags-input" name="sendTo" id="sendTo"
                                [identifyBy]="'id'" [displayBy]="'name'" [(ngModel)]="selectedEmailSendToObjectsArray"
                                [onlyFromAutocomplete]="false" [addOnBlur]="false" [addOnPaste]="false"
                                [onAdding]="validateTypeAheadTag" [placeholder]="userSearchPlaceholder" [secondaryPlaceholder]="userSearchPlaceholder"
                                (onAdd)="emailTypeAheadAdded($event, 'emailUsers')" (onRemove)="emailTypeAheadRemoved($event, 'emailUsers')">
                                <ng-template let-item="item" let-index="index">
                                    <span class="px-3 d-block d-flex" [ngClass]="getCustomTagClass(item)" (click)="onTagClicked(item)">
                                        <span class="pr-3 d-block">{{ item.name }}</span>
                                        <delete-icon style="width: 12px; height: 12px;" (click)="sendToInput.removeItem(item, index); $event.stopPropagation()"></delete-icon>
                                    </span>
                                </ng-template>
                                <tag-input-dropdown [identifyBy]="'id'" [displayBy]="'name'" [autocompleteObservable]="getEmailIdsToObservable" [limitItemsTo]="1000">
                                    <ng-template let-item="item" let-index="index">
                                        <div [ngClass]="getCustomAutoCompleteClass(item)">
                                            <p class="my-2 font-bold" style="font-size: 15px">{{ item.firstName || '' }} {{ item.lastName || '' }}</p>
                                            <p class="mb-2" style="font-size: 14px">{{ item.email }}{{ item.companyName ? ', ' + item.companyName : '' }}</p>
                                        </div>
                                    </ng-template>
                                </tag-input-dropdown>
                            </tag-input>
                        </div>
                        <div class="form-group d-flex align-items-center send-email-fields">
                            <label for="cc" class="control-label test-nowrap">
                                Cc :
                            </label>
                            <div *ngIf="!isPrePopulatedUsersAvailable" class="width-100 skeleton-container">
                                <div class="skeleton-heading width-75 skeleton-loading my-0"></div>
                            </div>
                            <tag-input *ngIf="isPrePopulatedUsersAvailable" #ccInput class="width-100 email-tags-input" name="cc" id="cc"
                                [identifyBy]="'id'" [displayBy]="'name'" [(ngModel)]="selectedEmailCCObjectsArray"
                                [onlyFromAutocomplete]="false" [addOnBlur]="false" [addOnPaste]="false"
                                [onAdding]="validateTypeAheadTag" [placeholder]="userSearchPlaceholder" [secondaryPlaceholder]="userSearchPlaceholder"
                                (onAdd)="emailTypeAheadAdded($event, 'ccUsers')" (onRemove)="emailTypeAheadRemoved($event, 'ccUsers')">
                                <ng-template let-item="item" let-index="index">
                                    <span class="px-3 d-block d-flex" [ngClass]="getCustomTagClass(item)" (click)="onTagClicked(item)">
                                        <span class="pr-3 d-block">{{ item.name }}</span>
                                        <delete-icon style="width: 12px; height: 12px;" (click)="ccInput.removeItem(item, index); $event.stopPropagation()"></delete-icon>
                                    </span>
                                </ng-template>
                                <tag-input-dropdown [identifyBy]="'id'" [displayBy]="'name'" [autocompleteObservable]="getEmailIdsCcObservable" [limitItemsTo]="1000">
                                    <ng-template let-item="item" let-index="index">
                                        <div [ngClass]="getCustomAutoCompleteClass(item)">
                                            <p class="my-2 font-bold" style="font-size: 15px">{{ item.firstName || '' }} {{ item.lastName || '' }}</p>
                                            <p class="mb-2" style="font-size: 14px">{{ item.email }}{{ item.companyName ? ', ' + item.companyName : '' }}</p>
                                        </div>
                                    </ng-template>
                                </tag-input-dropdown>
                            </tag-input>
                        </div>
                        <div class="form-group d-flex align-items-center send-email-fields">
                            <label for="bcc" class="control-label test-nowrap">
                                Bcc :
                            </label>
                            <div *ngIf="!isPrePopulatedUsersAvailable" class="width-100 skeleton-container">
                                <div class="skeleton-heading width-75 skeleton-loading my-0"></div>
                            </div>
                            <tag-input *ngIf="isPrePopulatedUsersAvailable" #bccInput class="width-100 email-tags-input" name="bcc" id="bcc"
                                [identifyBy]="'id'" [displayBy]="'name'" [(ngModel)]="selectedEmailBCCObjectsArray"
                                [onlyFromAutocomplete]="false" [addOnBlur]="false" [addOnPaste]="false"
                                [onAdding]="validateTypeAheadTag" [placeholder]="userSearchPlaceholder" [secondaryPlaceholder]="userSearchPlaceholder"
                                (onAdd)="emailTypeAheadAdded($event, 'bccUsers')" (onRemove)="emailTypeAheadRemoved($event, 'bccUsers')">
                                <ng-template let-item="item" let-index="index">
                                    <span class="px-3 d-block d-flex" [ngClass]="getCustomTagClass(item)" (click)="onTagClicked(item)">
                                        <span class="pr-3 d-block">{{ item.name }}</span>
                                        <delete-icon style="width: 12px; height: 12px;" (click)="bccInput.removeItem(item, index); $event.stopPropagation()"></delete-icon>
                                    </span>
                                </ng-template>
                                <tag-input-dropdown [identifyBy]="'id'" [displayBy]="'name'" [autocompleteObservable]="getEmailIdsBccObservable" [limitItemsTo]="1000">
                                    <ng-template let-item="item" let-index="index">
                                        <div [ngClass]="getCustomAutoCompleteClass(item)">
                                            <p class="my-2 font-bold" style="font-size: 15px">{{ item.firstName || '' }} {{ item.lastName || '' }}</p>
                                            <p class="mb-2" style="font-size: 14px">{{ item.email }}{{ item.companyName ? ', ' + item.companyName : '' }}</p>
                                        </div>
                                    </ng-template>
                                </tag-input-dropdown>
                            </tag-input>
                        </div>
                        <div class="form-group d-flex align-items-center send-email-fields mb-0"
                            [ngClass]="{'has-error': (emailDocumentsForm.submitted && subject.invalid)}">
                            <label for="subject" class="control-label" style="width: 70px;">
                                Subject :
                            </label>
                            <input type="text"
                                class="form-control width-100"
                                id="subject"
                                name="subject"
                                #subject="ngModel"
                                [(ngModel)]="emailDetails.subject"
                                required
                                placeholder="Subject">
                        </div>
                    </div>

                    <div class="col-xs-12 mt-5">
                        <app-email-html-editor [candidateInfoList]="candidateInformationList"
                            [documentsSectionHtml]="documentsSectionHtml"
                            [hideIncludeDetails]="true"
                            [externalCandidateAction]="externalCandidateAction"
                            (htmlContentChange)="emailContentChange($event)"
                            (selectedFieldsChange)="onSelectedFieldsChange($event)"
                            (candidateSelectionSync)="onCandidateSelectionSync($event)">
                        </app-email-html-editor>
                    </div>
                    </div><!-- end left column -->

                    <!-- Right Column: Include Details + Attached Documents -->
                    <div class="col-xs-6 px-0">
                    <!-- Include Details Checkboxes -->
                    <div class="col-xs-12" style="padding-left: 2.5rem;" id="includeDetailsSection">
                        <app-include-details-checkboxes
                            [candidateInformationList]="candidateInformationList"
                            [selectAll]="selectAllCandidatesExternal"
                            [title]="'INCLUDE THE FOLLOWING IN EMAIL BODY:'"
                            [checkboxPrefix]="'candidate-ext'"
                            [selectedProp]="'selected'"
                            [isNotesContext]="false"
                            (selectAllToggle)="onExternalSelectAll($event)"
                            (candidateToggle)="onExternalCandidateToggle($event)">
                        </app-include-details-checkboxes>
                    </div>

                    <!-- Attached Documents -->
                    <div class="col-xs-12 mt-5" style="padding-left: 2.5rem;" id="attachDocumentsSection">
                        <div class="col-xs-12 px-0 mb-4">
                            <div class="col-xs-12 px-0 mb-3 text-muted">
                                <span style="font-size:12px; font-weight:bold;">ATTACH DOCUMENTS:</span>
                            </div>
                            <div *ngIf="candidateAssessmentFiles.length === 0" class="text-muted my-2">
                                <span class="ml-5 my-2">No documents to attach.</span>
                            </div>
                            <div *ngIf="candidateAssessmentFiles.length > 0">
                                <div class="col-xs-12 col-md-6 px-0" *ngFor="let file of candidateAssessmentFiles; let i = index; trackBy: trackByIndex">
                                    <div class="name">
                                        <div class="checkbox-nice d-flex">
                                            <input type="checkbox" class="access" id="{{file.name}}"
                                                [value]="file.isSelected" [(ngModel)]="file.isSelected" [ngModelOptions]="{standalone: true}"
                                                (change)="onAssessmentFileChange()" />
                                            <label class="oneemfontsize text-nowrap mx-2" for="{{file.name}}">{{file.name}}</label>
                                            <span class="email-documents-resume-checkbox">(</span>
                                            <div class="text-nowrap text-overflow-ellipsis mx-1" style="padding-top: 3px;" tooltip="{{file.resumeNameOrXrXml}}" container="body" [adaptivePosition]="false">{{file.resumeNameOrXrXml}}</div>
                                            <span class="email-documents-resume-checkbox pr-2">)</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-xs-12 px-0">
                            <span class="mt-3 text-muted mb-3 mr-4"
                                style="font-size:12px; font-weight:bold;">
                                ATTACH OTHER DOCUMENTS
                                <i [ngClass]="{'opacity-half pointer-events-none': !isExistingDocumentsAvailable}" class="fas fa-paperclip attachment-clip py-2 ml-2 cursor-pointer"
                                    tooltip="Attach documents from your system" [adaptivePosition]="false" (click)="attachDocumentsToEmail()"
                                    container="body">
                                </i>
                                <i [ngClass]="{'opacity-half pointer-events-none': !isExistingDocumentsAvailable}" class="fa fa-cloud py-2 ml-2 cursor-pointer position-relative" style="font-size: 17px;"
                                    tooltip="Attach existing documents of the candidate" (click)="attachDocuments()"
                                    container="body" [adaptivePosition]="false">
                                </i>
                            </span>
                            <div *ngIf="!fileUploadInProgressFlag" class="folders-container-2 mt-2" id="otherDocumentsSection" style="overflow-y: auto;">
                                <div class="position-relative d-flex flex-column rounded border p-4 folder-document"
                                    [ngClass]="{'bg-purple': file.shared}"
                                    *ngFor="let file of attachedDocuments; let i = index; trackBy: trackByIndex" (dblclick)="viewDocumentFIle(file)">
                                <div class="position-absolute" style="left:10px; top:4px">
                                    <small tooltip="Document version" container="body" [adaptivePosition]="false">V{{file.version}}</small>
                                </div>
                                <div class="position-absolute d-flex" style="top:5px;right:7px;">
                                    <a (click)="detachDocument(file)" tooltip="Remove Attachment" container="body" [adaptivePosition]="false">
                                        <i class="fas fa-minus-circle text-danger" style="font-size:20px"></i>
                                    </a>
                                </div>
                                <div class="border-bottom d-flex justify-content-center align-items-center cursor-pointer">
                                    <img
                                        class="pb-3"
                                        [src]="file.icon"
                                        alt=""
                                        style="height:80px">
                                    <i *ngIf="file.note && file.note.length>0" class="fas fa-clipboard text-primary" tooltip="{{file.note}}" [adaptivePosition]="false"></i>
                                </div>
                                <div>
                                    <strong class="p-2 d-block text-overflow-ellipsis" tooltip="{{file.displayFileName || file.fileName}}" container="body" style="max-width: 160px;" [adaptivePosition]="false">
                                        {{file.displayFileName || file.fileName}}
                                    </strong>
                                    <small class="pull-left pt-2 text-muted" *ngIf="file.shared && file.sharedTo.length>0">
                                        {{file.sharedToText}}
                                        <i class="fas fa-info-circle text-primary"
                                            [popover]="clientsPopover"
                                            popoverTitle="Shared with"
                                            triggers="mouseenter">
                                        </i>
                                        <ng-template #clientsPopover>
                                            <div *ngFor="let client of file.sharedTo">
                                                <span class="d-block">{{client.shortName}}</span>
                                            </div>
                                        </ng-template>
                                    </small>
                                    <small *ngIf="file.uploadedDate" class="pull-right pt-2 text-muted" container="body" tooltip="Uploaded On" [adaptivePosition]="false">
                                        {{file.uploadedDate | fourDotFiveDateFormatPipe}}
                                    </small>
                                </div>
                                </div>
                                <div *ngIf="attachedDocuments.length===0" class="flex-grow-1 text-center text-danger mt-5 pt-5">
                                    No documents attached.
                                </div>
                            </div>
                            <div *ngIf="fileUploadInProgressFlag" class="folders-container-2 mt-2" id="loadingSpinner">
                                <div class="position-relative d-flex flex-column rounded border p-4 folder-document skeleton-container" *ngFor="let placeholder of [1]">
                                    <div class="skeleton-img skeleton-loading mx-auto" style="width:80px;height:80px;border-radius:8px;"></div>
                                    <div class="skeleton-heading skeleton-loading mt-3 width-75 mx-auto"></div>
                                </div>
                            </div>
                            <!-- Dropzone for email file attachment -->
                            <div>
                                <form name="emailDocumentUploadDropzone" id="emailDocumentUploadDropzone" action="" enctype="multipart/form-data"
                                    [dropzone]="dropzoneConfig" (addedFile)="onEmailDocumentFileAdded($event)"
                                    (sendingMultiple)="onEmailDocumentFileSendingMultiple($event)"
                                    (successMultiple)="onEmailDocumentFileSuccessMultiple($event)"
                                    (error)="onEmailDocumentFileError($event)"></form>
                            </div>
                        </div>
                    </div>
                    </div><!-- end right column -->

                    <div class="col-xs-12 text-right mt-5">
                        <div class="clearfix d-flex align-items-center justify-content-end">
                            <div class="name mr-4" *ngIf="showClientForReviewCheckbox">
                                <div class="checkbox-nice d-flex">
                                    <input type="checkbox" class="access" id="sendForReview" [(ngModel)]="isSendForReviewSelected" [ngModelOptions]="{standalone: true}" />
                                    <label class="ml-2 font-bold" style="font-size: 1.6rem; padding: 0;" for="sendForReview">Send to Client for Review</label>
                                </div>
                            </div>
                            <div class="">
                                <button type="button" class="btn btn-danger mr-2" (click)="cancel()"
                                    [disabled]="savingFlag || !isPrePopulatedUsersAvailable || fileUploadInProgressFlag || !isExistingDocumentsAvailable">
                                    <span>Cancel</span>
                                </button>
                            </div>
                            <div>
                                <button type="submit" class="btn btn-success"
                                    [disabled]="savingFlag || !isPrePopulatedUsersAvailable || fileUploadInProgressFlag || !isExistingDocumentsAvailable || selectedEmailSendToObjectsArray.length === 0">
                                    <span *ngIf="!savingFlag">Send Email</span>
                                    <span *ngIf="savingFlag">Sending..</span>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </div>
</div>
